import { Objective, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { objectiveClient, ObjectivePathParameters } from './ObjectiveClient';

const factory = createStudyEntityHookFactory<Objective, ObjectivePathParameters>(StudyEntityType.Objective);

export const useObjectives = factory.list(objectiveClient.list);
export const useObjective = factory.get(objectiveClient.get);
